export enum StylingProperty {
  Color = 'color',
  BackgroundColor = 'backgroundColor',
  BorderColor = 'borderColor',
  FillOpacity = 'fillOpacity',
  FontSize = 'fontSize',
  LineOpacity = 'lineOpacity',
  StrokeOpacity = 'strokeOpacity',
  StrokeStyle = 'strokeStyle',
  StrokeWidth = 'strokeWidth',
  ShowTitle = 'showTitle',
  ShowLength = 'showLength',
  ShowRadius = 'showRadius',
  ShowArea = 'showArea',
  ShowBorder = 'showBorder',
  Minimized = 'minimized',
  LabelAlwaysVisible = 'labelAlwaysVisible',
  ShowAsLeader = 'showAsLeader',
  ShowDescription = 'showDescription',
}

export const StyleMap: { [key: string]: StylingProperty[] } = {
  polygon: [
    StylingProperty.Color,
    StylingProperty.StrokeStyle,
    StylingProperty.ShowTitle,
    StylingProperty.ShowArea,
    StylingProperty.LabelAlwaysVisible,
    StylingProperty.StrokeWidth,
    StylingProperty.StrokeOpacity,
    StylingProperty.FillOpacity,
  ],
  line: [
    StylingProperty.Color,
    StylingProperty.StrokeStyle,
    StylingProperty.ShowTitle,
    StylingProperty.ShowLength,
    StylingProperty.LabelAlwaysVisible,
    StylingProperty.StrokeWidth,
    StylingProperty.StrokeOpacity,
  ],
  circle: [
    StylingProperty.Color,
    StylingProperty.StrokeStyle,
    StylingProperty.ShowRadius,
    StylingProperty.ShowArea,
    StylingProperty.StrokeOpacity,
    StylingProperty.FillOpacity,
  ],
  'arrow-standard': [
    StylingProperty.Color,
    StylingProperty.StrokeStyle,
    StylingProperty.ShowAsLeader,
    StylingProperty.ShowTitle,
    StylingProperty.LabelAlwaysVisible,
    StylingProperty.StrokeWidth,
    StylingProperty.StrokeOpacity,
  ],
  'arrow-standard-as-leader': [
    StylingProperty.Color,
    StylingProperty.StrokeStyle,
    StylingProperty.ShowAsLeader,
    StylingProperty.ShowTitle,
    StylingProperty.ShowDescription,
    StylingProperty.StrokeWidth,
    StylingProperty.StrokeOpacity,
  ],
  'arrow-metadata': [
    StylingProperty.Color,
    StylingProperty.StrokeStyle,
    StylingProperty.StrokeWidth,
    StylingProperty.StrokeOpacity,
  ],
  marker: [StylingProperty.Color],
  text: [StylingProperty.Color, StylingProperty.BackgroundColor, StylingProperty.BorderColor, StylingProperty.FontSize],
  textV2: [StylingProperty.Color, StylingProperty.BackgroundColor, StylingProperty.BorderColor],
  image: [StylingProperty.ShowBorder, StylingProperty.Minimized, StylingProperty.FillOpacity],
  'image-with-border': [
    StylingProperty.ShowBorder,
    StylingProperty.Minimized,
    StylingProperty.Color,
    StylingProperty.StrokeStyle,
    StylingProperty.StrokeWidth,
    StylingProperty.StrokeOpacity,
    StylingProperty.FillOpacity,
  ],
  stamp: [StylingProperty.FillOpacity],
};
